import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ProfileComponent } from './dashboard/profile/profile.component';
import { StoreListComponent } from './dashboard/store/list/list.component';
import { SubscriptionComponent } from './dashboard/subscription/subscription.component';
import { AuthGuard } from './auth.guard';
import { ErrorPageComponent } from './error-page/error-page.component';
import { ExternalRedirectComponent } from './common/components/external-redirect/external-redirect.component';

const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    component: DashboardComponent,
    children: [
      { path: '', redirectTo: 'waste-cards/index', pathMatch: 'full' },
      { path: 'profile', component: ProfileComponent },

      { path: 'users', component: ExternalRedirectComponent },
      { path: 'companies', component: ExternalRedirectComponent },
      { path: 'companies/:id/details', component: ExternalRedirectComponent },

      {
        path: "store", children: [
          { path: '', redirectTo: 'plans', pathMatch: 'full' },
          { path: 'plans', component: StoreListComponent },
        ]
      },
      {
        path: 'waste-register',
        loadChildren: () => import('./dashboard/waste-register/waste-register.module').then(m => m.WasteRegisterModule),
        data: {
          role: 'EVIDENCE',
          preload: true
        },
        canActivateChild: [AuthGuard]
      },
      {
        path: 'waste-cards',
        loadChildren: () => import('./dashboard/waste-cards/waste-cards.module').then(m => m.WasteCardsModule),
        canActivateChild: [AuthGuard],
        data: { preload: true }
      },
      {
        path: 'productreport', loadChildren: () => import('./dashboard/productreport/productreport.module').then(m => m.ProductReportModule),
        canActivateChild: [AuthGuard]
      },
      {
        path: 'reports', loadChildren: () => import('./dashboard/reports/reports.module').then(m => m.ReportsModule),
        data: {
          role: 'REPORTS'
        },
        canActivateChild: [AuthGuard]
      },
      {
        path: 'subscription', component: SubscriptionComponent
      },
      {
        path: 'packaging', loadChildren: () => import('./dashboard/packaging/packaging.module').then(m => m.PackagingModule),
        canActivateChild: [AuthGuard]
      },
      {
        path: 'manufacturingreport', loadChildren: () => import('./dashboard/manufacturingreport/manufacturingreport.module').then(m => m.ManufacturingReportModule),
        canActivateChild: [AuthGuard]
      },
      {
        path: 'admin',
        loadChildren: () => import('./dashboard/admin/admin.module').then(m => m.AdminModule),
        canActivate: [AuthGuard],
        data: { roles: ['ADMIN'] },
        canActivateChild: [AuthGuard]
      }
    ],
  },
  { path: '404', component: ErrorPageComponent },
  { path: '500', component: ErrorPageComponent },
  { path: '**', redirectTo: '404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
